import { CheckboxAll } from "./components";
import style from "./TableHead.module.scss";

export function TableHead() {

    return (
        <div className={style.head}>
            <div>
                <CheckboxAll />
            </div>
            <div>ID</div>
            <div>Ім'я</div>
            <div></div>
        </div>
    )
}